var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirlRedbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 576,
    viewBox: "0 0 278 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.09786e-05 1.77308e-05L-3.61563e-05 576C153.796 576 278 446.897 278 288C278 129.103 153.796 2.44535e-05 -1.09786e-05 1.77308e-05Z",
    fill: "#FF0336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlRedbg);
export default __webpack_public_path__ + "static/media/girl-redbg.f8dedc2cc0539fb0e60979db3b5245da.svg";
export { ForwardRef as ReactComponent };